export interface MetricValue {
  value: number
  createdAt: string
  avg?: number
  count?: number
  metric_id?: string
  simulationOutputCreatedAt?: string
  runCreatedAt?: string
  occurredAt?: string
  metricId: string
  runId?: string
  simulationOutputId?: string
  explanation?: string
  errorMessage?: string | null
  errorStatus?: string | null
  customerMetadata?: Record<string, unknown>
  metadataValue?: string
  agentId?: string
  agentName?: string
  run_agent_id?: string
  personaId?: string
  personaName?: string
  persona_id?: string
  templateName?: string
  run_template_name?: string
  testSetId?: string
  testSetName?: string
  test_set_id?: string
  mutation_id?: string
  mutationName?: string
  assignee?: string
  [key: string]: unknown
}

export const extractTimestamp = (point: MetricValue): number => {
  return new Date(
    point.occurredAt ||
      point.runCreatedAt ||
      point.simulationOutputCreatedAt ||
      point.createdAt,
  ).getTime()
}

export const basicAggregations = {
  sum: (values: number[]): number => values.reduce((a, b) => a + b, 0),
  count: (values: number[]): number => values.length,
  avg: (values: number[]): number =>
    values.reduce((a, b) => a + b, 0) / values.length,
  max: (values: number[]): number => Math.max(...values),
  min: (values: number[]): number => Math.min(...values),
}
